import React, { useEffect } from "react";
import styles from "./styles.module.css";
import AnimatedNudge from "../AnimatedNudge";
import hexagonShape from "../../../assets/hexagon-shape-icon.svg";
import { getWidth } from "../../../utils/relativeSizes";
import clsx from "clsx";
import { useSelector } from "react-redux";
import { getShowEndGameNudge } from "../store/actions";
import { useTranslation } from "react-i18next";
import { GAMEPLAY_ANIMATION_IMAGES } from "../../../assets";
// import { playStartSoundOfGame } from "classes/voiceovers/GameSoundManager";

// const _playStartSound = () => {
//   playStartSoundOfGame();
// };

function EndGameAnimation() {
  const { t } = useTranslation();
  const showEndGameNudge = useSelector(getShowEndGameNudge);

  useEffect(() => {
    if (showEndGameNudge) {
      // setTimeout(_playStartSound, 500);
    }
  }, [showEndGameNudge]);

  if (!showEndGameNudge) {
    return null;
  }

  return (
    <AnimatedNudge>
      <div 
        className={clsx(styles.wrapper, "hexagonShapeWrapper")}
        style={{ 
          backgroundImage: `url(${GAMEPLAY_ANIMATION_IMAGES.hexagonShape})`, 
          width: getWidth(110), 
          height: getWidth(72)
        }}
      >
        <div className={clsx(styles.text, "hexagonShapeText fontSizeSm14 fontWeight900 textUppercase fontColorDarkBlue2 flex alignItemCenter justifyContentCenter relative")}>{t("gameEnds")}</div>
      </div>
    </AnimatedNudge>
  );
}

export default EndGameAnimation;
